export default __webpack_public_path__ + "static/IvarHeadline-Regular-e52245af5f64a81128e1e28687949511.woff";